import {VGNav} from "vgnav";
import {Popover, Tooltip, VegasCarousel, VegasModal} from "../../index.esm";

const VegasUI = {
	vgNav: function () {
		new VGNav({
			expand: 'lg'
		});
	},

	carousel: function () {
		VegasCarousel.init();
	},

	modal: function () {
		$('[data-modal]').click(function () {
			VegasModal.init($(this))

			return false;
		});
	},

	boot: () => {
		// Popovers
		let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
		popoverTriggerList.map(function (popoverTriggerEl) {
			return new Popover(popoverTriggerEl, {
				html: true,
				container: 'body',
			})
		});

		// Tooltip
		let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
		tooltipTriggerList.map(function (tooltipTriggerEl) {
			return new Tooltip(tooltipTriggerEl, {
				trigger: 'hover'
			})
		})
	},

	niceSelect: () => {
		$('.nice-select').niceSelect();
	},

	fancybox: () => {
		// fancybox remove zoom image
		fbx.Fancybox.bind("[data-fancybox]", {
			Image: {
				zoom: false,
			},
		});
	}
}

function onReady() {
	// Навигация
	VegasUI.vgNav();

	// Карусель
	VegasUI.carousel();

	// Модалка
	VegasUI.modal();

	// Boot
	VegasUI.boot();

	// Nice Select
	VegasUI.niceSelect();

	// Fancybox
	VegasUI.fancybox();
}

document.addEventListener("DOMContentLoaded", onReady);

export default VegasUI;